import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

const Loader: React.FC = () => {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      maxHeight="100vh" // Adjust the height based on your layout
    >
      <CircularProgress />
    </Box>
  );
};

export default Loader;